export default __webpack_public_path__ + "static/media/feature-cybersecurity-1.4cf23b99.png";